import {
  faUsers,
  faPersonChalkboard,
  faFilePowerpoint,
  faGears,
  faBullhorn,
  faChalkboardUser,
  faStar,
  faImages,
  faBell,
} from "@fortawesome/free-solid-svg-icons";

export const links = [
  {
    name: "الطلاب",
    path: "/dashboard/users",
    icon: faUsers,
  },
  {
    name: "الصفوف",
    path: "/dashboard/classes",
    icon: faChalkboardUser,
  },
  {
    name: "المواد",
    path: "/dashboard/categories",
    icon: faPersonChalkboard,
  },
  {
    name: "الدروس",
    path: "/dashboard/products",
    icon: faFilePowerpoint,
  },
  {
    name: "الدورات المكثفة",
    path: "/dashboard/T_Intensive",
    icon: faGears,
  },
  {
    name: "الإعلانات",
    path: "/dashboard/T_Ads",
    icon: faBullhorn,
  },
  {
    name: "الطلاب المتميزون",
    path: "/dashboard/excellent",
    icon: faStar,
  },
  {
    name: "الإشعارات",
    path: "/dashboard/notifications",
    icon: faBell,
  },
  {
    name: "معرض الصور",
    path: "/dashboard/gallery",
    icon: faImages,
  },
];
